import { useEffect } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { emitterChangeAPI } from 'entities/Auth/lib/change_api_domain'

export const useEventChangeApi = () => {
  const { websocket } = useEntitiesContext()

  const callback = () => {
    websocket.reinit()
  }

  useEffect(() => {
    emitterChangeAPI.subscribe('change_api', callback)

    return () => {
      emitterChangeAPI.unsubscribe('change_api', callback)
    }
  }, [])
}
